module.exports = __webpack_public_path__ + "static/media/bbc_news_world-europe-36800730_plot.71bfd8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_world-europe-36800730_plot.png
// module id = 361
// module chunks = 0